export const STRIPE_NL = 'STRIPE_NL';
export const STRIPE_US = 'STRIPE_US';
export const STRIPE_JP = 'STRIPE_JP';
export const TNS = 'TNS';
